import { AbstractParseTreeVisitor } from 'antlr4ts/tree/index.js';
import { BadImplementationException } from '@nu-art/ts-common';
import { Operator_ADDITION, Operator_AND, Operator_DIV, Operator_EQUAL, Operator_Func_If, Operator_GREATER_THAN, Operator_IN_RANGE, Operator_LESSER_THAN, Operator_MOD, Operator_MULTIPLICATION, Operator_OR, Operator_POWER, Operator_SUBTRACT } from '@app/hcs-shared/expression/index';
import { ModuleFE_Value } from '../../../../../_entity/value/index.js';
import { Operator_GetPatientVar } from '../../../modules/expression-module-quai/consts.js';
import { valueType_EnumElement } from '@app/hcs-shared/core';
const variablesBlackbox = {
    '50936967ef0beed086c159c5dc09bbe2': {
        number: 3,
        boolean: true,
        string: 'zevel',
        nested: {
            anotherString: 'ashpa'
        }
    },
    '7b9c2f60a3725306be9c0b696320c4c1': {
        name: 'gender'
    },
    '7aa6b7d572ec8538e2fc35b8354e8011': {
        min: 200,
        max: 500
    }
};
export class ExpressionJsonVisitor extends AbstractParseTreeVisitor {
    constructor(withLog = false) {
        super();
    }
    defaultResult() {
        return {};
    }
    visitBooleanOperationExpr(ctx) {
        return this.visit(ctx.boolExpr0());
    }
    visitBooleanEqualityExpr(ctx) {
        return { op: Operator_EQUAL, params: [this.visit(ctx.boolExpr0()), this.visit(ctx.boolExpr1())] };
    }
    visitArithmeticOperationExpr(ctx) {
        return this.visit(ctx.numericExpr0());
    }
    visitAtomicExpr(ctx) {
        return this.visit(ctx.stringExpr0());
    }
    visitStringExpr(ctx) {
        return ctx.STRING().text.replace(/"/g, '');
    }
    visitParenExpr(ctx) {
        return this.visit(ctx.expression());
    }
    visitParenBooleanOperation(ctx) {
        return this.visit(ctx.boolExpr0());
    }
    visitAdditionOperation(ctx) {
        return { op: Operator_ADDITION, params: [this.visit(ctx.numericExpr0()), this.visit(ctx.numericExpr1())] };
    }
    visitSubtractionOperation(ctx) {
        return { op: Operator_SUBTRACT, params: [this.visit(ctx.numericExpr0()), this.visit(ctx.numericExpr1())] };
    }
    visitPassThroughArithmeticTerm(ctx) {
        return this.visit(ctx.numericExpr1());
    }
    visitMultiplicationOperation(ctx) {
        return { op: Operator_MULTIPLICATION, params: [this.visit(ctx.numericExpr1()), this.visit(ctx.numericExpr2())] };
    }
    visitDivisionOperation(ctx) {
        return { op: Operator_DIV, params: [this.visit(ctx.numericExpr1()), this.visit(ctx.numericExpr2())] };
    }
    visitModuloOperation(ctx) {
        return { op: Operator_MOD, params: [this.visit(ctx.numericExpr1()), this.visit(ctx.numericExpr2())] };
    }
    visitPowerOperation(ctx) {
        return { op: Operator_POWER, params: [this.visit(ctx.numericExpr3()), this.visit(ctx.numericExpr2())] };
    }
    visitNumberLiteral(ctx) {
        return parseFloat(ctx.NUMBER().text);
    }
    visitParenArithmeticOperation(ctx) {
        return this.visit(ctx.numericExpr0());
    }
    visitAndOperation(ctx) {
        return { op: Operator_AND, params: [[this.visit(ctx.boolExpr1()), this.visit(ctx.boolExpr2())]] };
    }
    visitNumericEqaulComparison(ctx) {
        return { op: Operator_EQUAL, params: [this.visit(ctx.numericExpr0(0)), this.visit(ctx.numericExpr0(1))] };
    }
    visitAtomicEqualComparison(ctx) {
        return { op: Operator_EQUAL, params: [this.visit(ctx.stringExpr0(0)), this.visit(ctx.stringExpr0(1))] };
    }
    visitOrOperation(ctx) {
        return { op: Operator_OR, params: [[this.visit(ctx.boolExpr0()), this.visit(ctx.boolExpr1())]] };
    }
    visitNotOperation(ctx) {
        return !this.visit(ctx.boolExpr4());
    }
    visitLessThanComparison(ctx) {
        return { op: Operator_LESSER_THAN, params: [this.visit(ctx.numericExpr0(0)), this.visit(ctx.numericExpr0(1))] };
    }
    visitGreaterThanComparison(ctx) {
        return { op: Operator_GREATER_THAN, params: [this.visit(ctx.numericExpr0(0)), this.visit(ctx.numericExpr0(1))] };
    }
    visitNegativeExpression(ctx) {
        const value = this.visit(ctx.numericExpr3());
        return -value;
    }
    visitResolvablesExpr(ctx) {
        return this.visit(ctx.resolvableExpr());
    }
    visitResolveVar(ctx) {
        return variablesBlackbox[ctx.UNIQUE_ID().text];
    }
    visitResolveProp(ctx) {
        const props = ctx.PROPERTY().map(terminalProp => terminalProp.text);
        return {
            op: Operator_GetPatientVar, params: [props.reduce((value, currentProp) => {
                    return value[currentProp];
                }, this.visit(ctx.resolveVar()))]
        };
    }
    visitResolveEnumerated(ctx) {
        const id = this.visit(ctx.resolveEnum());
        const enumValue = ModuleFE_Value.cache.unique(id);
        if (!enumValue)
            throw new BadImplementationException(`no value found for id: ${id}`);
        if (enumValue.type !== valueType_EnumElement)
            throw new BadImplementationException(`value with id ${id} is not enum type, actual type: ${enumValue.type}`);
        return { op: 'enum', params: [enumValue.data.value] };
    }
    visitResolveYesNo(ctx) {
        if (ctx.resolveNo())
            return { op: 'boolean value', params: [this.visit(ctx.resolveNo())] };
        if (ctx.resolveYes())
            return { op: 'boolean value', params: [this.visit(ctx.resolveYes())] };
    }
    visitResolveEnum(ctx) {
        return ctx.UNIQUE_ID().text;
    }
    visitResolveYes(ctx) {
        return 'yes';
    }
    visitResolveNo(ctx) {
        return 'no';
    }
    visitConditionExpr(ctx) {
        return this.visit(ctx.conditionalExpr0());
    }
    visitGeneralCondition(ctx) {
        return {
            op: Operator_Func_If,
            params: [this.visit(ctx.boolExpr0()), this.visit(ctx.expression(0)), this.visit(ctx.expression(1))]
        };
    }
    visitInRange(ctx) {
        return {
            op: Operator_IN_RANGE,
            params: [this.visit(ctx.numericExpr0(1)), [this.visit(ctx.numericExpr0(0)), this.visit(ctx.numericExpr0(2))]]
        };
    }
    visitBooleanLiteral(ctx) {
        return ctx.BOOL().text === 'true';
    }
}
//# sourceMappingURL=ExpressionJsonVisitor.js.map